import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ITextFeatureWithDescriptionProps } from '../components/text-feature-with-description/text-feature-with-description';
import { TextAlignType } from '../typings/';

export class TextFeatureWithDescription extends ContentItem {
  get theme(): string {
    return get(this._config, 'elements.theme.value[0].codename', '');
  }

  get featureText(): string {
    return get(this._config, 'elements.feature_text.value', '');
  }

  get featureTextAligment(): TextAlignType {
    return get(
      this._config,
      'elements.feature_text_aligment.value[0].codename',
      ''
    );
  }

  get featureTextWeight(): string {
    return get(
      this._config,
      'elements.feature_text_weight.value[0].codename',
      ''
    );
  }

  get description(): string {
    return get(this._config, 'elements.desc.value', '');
  }

  get descriptionTextAligment(): TextAlignType {
    return get(
      this._config,
      'elements.description_text_aligiment.value[0].codename',
      ''
    );
  }

  get descriptionTextWeight(): string {
    return get(
      this._config,
      'elements.description_text_weight.value[0].codename',
      ''
    );
  }

  get hasCountingAnimation(): boolean {
    return (
      get(
        this._config,
        'elements.has_counting_animation.value[0].codename',
        ''
      ) === 'true'
    );
  }

  get countingNumberPrefix(): string {
    return get(this._config, 'elements.counting_number_prefix.value', '');
  }

  get countingNumberSufix(): string {
    return get(this._config, 'elements.counting_number_sufix.value', '');
  }

  public static create(
    data: ITextFeatureWithDescription
  ): ITextFeatureWithDescriptionProps {
    const {
      theme,
      featureText,
      featureTextAligment,
      featureTextWeight,
      description,
      descriptionTextAligment,
      descriptionTextWeight,
      hasCountingAnimation,
      countingNumberPrefix,
      countingNumberSufix
    } = new TextFeatureWithDescription(data);
    return {
      theme,
      featureText,
      featureTextAligment,
      featureTextWeight,
      description,
      descriptionTextAligment,
      descriptionTextWeight,
      hasCountingAnimation,
      countingNumberPrefix,
      countingNumberSufix
    };
  }
}
